import * as React from 'react';

import { Unit } from '@rematter/frontend-lib-api-client';

import { shortenUnit } from '../../lib';

export type MeasuredValueProps = {
  value?: number | null;
  unit?: Unit | null;
  minimumFractionDigits?: number;
  maximumFractionDigits?: number;
};

export const MeasuredValue = ({
  value,
  unit,
  minimumFractionDigits = 0,
  maximumFractionDigits = 2,
}: MeasuredValueProps) => {
  const shortenedUnit = React.useMemo(() => shortenUnit(unit) ?? unit, [unit]);

  return (
    <div className="@MeasuredValue contents">
      {Intl.NumberFormat('en-US', {
        minimumFractionDigits,
        maximumFractionDigits,
      }).format(value ?? 0)}
      {unit && (
        <span className="ml-[.25em] font-light opacity-60">
          {shortenedUnit}
        </span>
      )}
    </div>
  );
};
